<template>
    <el-button v-if="componentShow" :type="type" @click="methodFun" :loading="queryLoading" :class="btClass" :disabled="disabled">{{text}}</el-button>
</template>

<script>
    export default {
        name: "ZmButton",
        props: {
            type:{
                type:String
            },
            btClass:{
                type:String
                // default:'zm-button2'
            },
            text:{
                type:String,
                required:true
            },
            method:{
                type:String,
                default:'post'
            },
            /*url:{
                type:String,
                required:true
            },*/
            getParams:{
                type:Function,
                required: true
            },
            beforeClick:{
                type:Function
            },
            disabled:{
                type:Boolean,
                default:false
            },
            timeout:{
                type:Number,
                default:20000
            },
            showMsg:{
                type:Boolean,
                default:true
            }
        },
        data(){
          return {
              queryLoading:false,
              componentShow:true
          }
        },
        computed:{

        },
        methods: {
            methodFun(){
                if(this.beforeClick){
                    this.beforeClick().then(() => {
                        this.requestFun();
                    }).catch(() => {});
                }else{
                    this.requestFun();
                }
            },
            requestFun(){
                var params = this.getParams();
                if(params && params.url){
                    this.queryLoading = true;
                    let _option = {
                        timeout:this.timeout
                    }
                    if(!this.showMsg){
                        _option.isShowMessage = 1;
                    }
                    if(this.method == 'post'){
                        this.$httpService.post(params.url,params.params,_option).then(res =>{
                            this.queryLoading = false;
                            this.$emit('success',res);
                        }).catch(res => {
                            this.queryLoading = false;
                            this.$emit('error',res);
                        });
                    }else if(this.method == 'post1'){
                        _option.contentType = 2;
                        this.$httpService.post(params.url,params.params,_option).then(res =>{
                            this.queryLoading = false;
                            this.$emit('success',res);
                        }).catch(res => {
                            this.queryLoading = false;
                            this.$emit('error',res);
                        });
                    }else{
                        this.$httpService.get(params.url,params.params,_option).then(res =>{
                            this.queryLoading = false;
                            this.$emit('success',res);
                        }).catch(res => {
                            this.queryLoading = false;
                            this.$emit('error',res);
                        });
                    }

                }
            }

        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ZmButton/index.vue